import { defineStyleConfig as a } from "@chakra-ui/react";
const e = a({
  baseStyle: {
    '&[data-attached="true"]': {
      width: "fit-content"
    },
    '&[data-attached="true"] label': {
      borderRadius: "none"
    },
    '&[data-attached="true"] div:first-of-type label': {
      borderStartRadius: "lg"
    },
    '&[data-attached="true"] div:last-of-type label': {
      borderEndRadius: "lg"
    },
    '&[data-attached="true"] :not(div:last-of-type) label': {
      marginInlineEnd: "-1px"
    },
    '&[data-attached="true"] label:focus-within': {
      zIndex: 1
    },
    '&[data-attached="true"][data-invalid="true"]': {
      boxShadow: "0px 0px 0px 2px var(--sgi-colors-red-500)",
      webkitBoxShadow: "0px 0px 0px 2px var(--sgi-colors-red-500)",
      borderRadius: "lg"
    },
    '&[data-attached="true"][data-invalid="true"] label': {
      boxShadow: "none",
      WebkitBoxShadow: "none"
    },
    '&[data-attached="true"][data-invalid="true"] label:focus-within': {
      boxShadow: "invalidOutline"
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
});
export {
  e as default
};
